import React, { useEffect, useState } from "react";
import { InputBox, Password } from "../../components/CustomWidgets/InputBox";
import SelectBox from "../CustomWidgets/SelectBox";
import UploadMediaonly from "../upload-imageonly";
import {
  createStoreUser,
  getStoreUsers,
  updateStoreUser,
  UserImageUpload,
} from "../../API  Functions/UserMangement";
import "../../styles.css";
import UsermanagementPopup from "../../Popups/usermanagementPopup";
import { useSelector } from "react-redux";
import { addUserSchema } from "../validationSchema";
import { useTranslation } from "react-i18next";
import image from "../../assets/Images/roundimage.png";
import LoadingSpinner from "../Loading";
import { toast } from "react-toastify";
import { DoubleRightOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { Link } from "react-router-dom";
import {
  GetOrderFrom,
  GetPaymentMethods,
  GetSelectedMethods,
  updateOrderFrom,
  updatePaymentModes,
  updateUserRights,
} from "../../API  Functions/CashierSetup";
import {
  GetRetailerDetails,
  UpdateRetailerDetails,
} from "../../API  Functions/ProfileFunctions";
import { uploadImage } from "../../API  Functions/InventoryFunctions";
import UserRightsTable from "./UserRightsTable";
import { createRoot } from 'react-dom/client';
import InventoryOnboardPopup from "../../Popups/InventoryOnboardPopup";
import { checkPermission } from "../../Utils/permissionHelper";
import SearchBox from "../CustomWidgets/SearchBox";

const CashierModulesAccess = () => {
  const { t, i18n } = useTranslation();

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
const [allUsers, setAllUsers] = useState([]); // 🔹 backup for search

  useEffect(() => {
    GetUserData();
  }, [])

  const GetUserData = async () => {
    try {
      const res1 = await getStoreUsers(user_id);

      if (res1?.result[0]?.status_code === 200) {
        const activeUsers = res1.result[0]?.response?.filter(user => user.active === true && user.user_type != "online_sale");
        setUserData(activeUsers);
        setAllUsers(activeUsers);
      } else {
        setUserData([]);
        setAllUsers([]);

      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    }
  };

  const handleCheckboxChange = (id, field, value) => {
    console.log(id, field, value);

    const updatedData = userData?.map((item) =>
      item.retailer_user_id === id ? { ...item, [field]: value } : item
    );
    setUserData(updatedData);
    setAllUsers(updatedData);
  };

  const handlePasswordChange = (id, value) => {
    const updatedData = userData?.map((item) =>
      item.retailer_user_id === id ? { ...item, pos_password: value } : item
    );
    setUserData(updatedData);
    setAllUsers(updatedData);
  };

  const UpdateUserRights = async () => {
    setLoading(true);
    const payload = {
      user_id: user_id,
      retailer_users: userData?.map((user) => ({
        user_id: user.retailer_user_id, // or user.user_id, depending on your structure
        is_dashboard_show: user.is_dashboard_show,
        is_password_restrict: user.is_password_restrict,
        show_orders: user.show_orders,
        show_credit: user.show_credit,
        pos_password: user.pos_password,
        is_favorite_show: user.is_favorite_show,
        is_all_categ_show: user.is_all_categ_show,
        is_allow_discount: user?.is_allow_discount,
        is_allow_product_shortcut: user?.is_allow_product_shortcut,
        is_allow_opening_cash: user?.is_allow_opening_cash,
        is_allow_negative_sale: user?.is_allow_negative_sale,
        is_allow_add_product: user?.is_allow_add_product

      })),
    }
    try {
      const res1 = await updateUserRights(payload);
      if (res1?.result[0]?.status_code == 200) {
        showModal('')
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const showModal = (message) => {
    const modalContainer = document.createElement('div');
    document.body.appendChild(modalContainer);

    const root = createRoot(modalContainer);

    const handleClose = () => {
      root.unmount();                     // Unmount the React component
      document.body.removeChild(modalContainer);  // Remove the container from the DOM
    };

    root.render(
      <InventoryOnboardPopup
        message={message}
        onClose={handleClose}
      />
    );
  };

    const searchUser = (searchText) => {
      console.log("searchText==>",searchText);
      
  if (!searchText || searchText.trim() === "") {
    setUserData(allUsers); // reset when empty
    return;
  }

  const text = searchText.toLowerCase();

const filteredUsers = allUsers.filter((user) => {
  const name = typeof user?.name === "string" ? user.name.toLowerCase() : "";
  const email =
    typeof user?.email === "string" ? user.email.toLowerCase() : "";
  const phone =
    typeof user?.phone === "string" ? user.phone.toLowerCase() : "";

  return (
    name.includes(text) ||
    email.includes(text) ||
    phone.includes(text)
  );
});


  setUserData(filteredUsers);
};

  return (
    <div className="mb-14 mt-4 mx-4">
      {loading && <LoadingSpinner />}

      {allUsers?.length > 0 &&
        <div className="flex gap-5 mt-5 self-end me-7  justify-between">
           <SearchBox
                  // showBarcode={true}
                  searchResult={(values) => searchUser(values)}
                  placeholder={t("Search Users")}
                />
      {userData?.length > 0 &&
          <button
            onClick={() => {
              if (checkPermission("/settings/cashiersetup", isGinne)) {
                UpdateUserRights();
              }
            }}
            className={`w-36 h-10 rounded-lg font-semibold ${"bg-primaryBlue text-white"
              }`}
          >
            {t("save")}
          </button>
}
        </div>
      }
      <div className="flex flex-col">
        <UserRightsTable
          tabledata={userData}
          handleCheckboxChange={handleCheckboxChange}
          handlePasswordChange={handlePasswordChange}
        />


      </div>
    </div>

  );
};

export default CashierModulesAccess;
